'use es6';

import { applySorting } from '../../modify/sorts/report-sort-utils';
import { ChannelNames } from '../../schema/visual-records';
import { applyDefaultAggregation, createMagicMeasure, getColumnAggregation, getColumnAlias } from '../../utils/column-utils';
import { addColumnToChannel } from '../../updaters/report';
import { applyModifiers } from '../../updaters/report/modifiers';
import { getTableList } from '../../utils/table-utils';
const aggregateColumns = (reportDefinition, groupByColumnId) => {
  const withDefaultAggregation = column => {
    const hasNoAggregation = getColumnAggregation(column) == null;
    const isGroupedByColumn = getColumnAlias(column) === groupByColumnId;
    return hasNoAggregation && !isGroupedByColumn ? applyDefaultAggregation(column) : column;
  };
  return reportDefinition.update('columns', columns => columns.map(withDefaultAggregation));
};
const moveGroupByColumnToFirstPosition = (reportDefinition, groupByColumnId) => reportDefinition.updateIn(['visual', 'encodings', 'columns'], columns => columns.sort(a => a.column === groupByColumnId ? -1 : 0));
const encodeMagicMeasures = (reportDefinition, deps) => {
  if (reportDefinition.visual.encodings.get(ChannelNames.COLUMNS) == null) {
    return reportDefinition;
  }
  const magicMeasures = getTableList(reportDefinition.table).map(table => createMagicMeasure(table)).filter(item => !!item);
  return magicMeasures.reduce((definition, measure) => addColumnToChannel(definition, {
    column: measure,
    channelName: ChannelNames.COLUMNS,
    deps
  }), reportDefinition);
};
export const groupByColumn = (reportDefinition, columnId, deps) => {
  const {
    meta
  } = deps;
  let next = reportDefinition;
  next = aggregateColumns(next, columnId);
  next = moveGroupByColumnToFirstPosition(next, columnId);
  next = encodeMagicMeasures(next, deps);
  next = applySorting(next, meta);
  return applyModifiers(next, deps);
};